import { designCenterConst } from "../constants/designCenterConst";

const initialState = {
  items: [],
  loading: false,
  error: null,
  views: [],
  assetsList: [],
  updateasset: {},
  assetDetail: {},
  assetsColorList: [],
  assetColorDetail: {},
  themeData: {},
  delete:{}
};
let items = [];
const designCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case designCenterConst.ADD_ASSET:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.ADD_ASSET_SUCCESS:
      return { ...state, loading: false, assetDetail: action.asset };

    case designCenterConst.ADD_ASSET_FAILURE:
      return { ...state, loading: false, error: action.error };

    case designCenterConst.VIEW_ALL_ASSETS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case designCenterConst.VIEW_ALL_ASSETS_SUCCESS:
      return { ...state, assetsList: action.allassets, loading: false };

    case designCenterConst.VIEW_ALL_ASSETS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case designCenterConst.DELETE_ASSET:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.DELETE_ASSET_SUCCESS:
      return { ...state, delete: action.asset, loading: false };

    case designCenterConst.DELETE_ASSET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case designCenterConst.UPDATE_ASSET:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.UPDATE_ASSET_SUCCESS:
      return { ...state, assetDetail: action.asset, loading: false };

    case designCenterConst.UPDATE_ASSET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case designCenterConst.VIEW_ASSET_DETAIL:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.VIEW_ASSET_DETAIL_SUCCESS:
      return { ...state, assetDetail: action.asset, loading: false };
    case designCenterConst.VIEW_ASSET_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case designCenterConst.VIEW_ALL_ASSETS_COLOR_REQUEST:
      return {
        ...state,
        loading: true
      };

    case designCenterConst.VIEW_ALL_ASSETS_COLOR_SUCCESS:
      return {
        ...state,
        assetsColorList: action.allAssetsColor,
        loading: false
      };

    case designCenterConst.VIEW_ALL_ASSETS_COLOR_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case designCenterConst.ADD_ASSET_COLOR:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.ADD_ASSET_COLOR_SUCCESS:
      return { ...state, loading: false, assetColorDetail: action.assetColor };

    case designCenterConst.ADD_ASSET_COLOR_FAILURE:
      return { ...state, loading: false, error: action.error };
    case designCenterConst.UPDATE_ASSET_COLOR:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.UPDATE_ASSET_COLOR_SUCCESS:
      return { ...state, assetColorDetail: action.assetColor, loading: false };

    case designCenterConst.UPDATE_ASSET_COLOR_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case designCenterConst.VIEW_ASSET_COLOR_DETAIL:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.VIEW_ASSET_COLOR_DETAIL_SUCCESS:
      return { ...state, assetColorDetail: action.assetColor, loading: false };
    case designCenterConst.VIEW_ASSET_COLOR_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case designCenterConst.VIEW_THEME_DATA:
      return {
        ...state,
        loading: true
      };
    case designCenterConst.VIEW_THEME_DATA_SUCCESS:
      return { ...state, themeData: action.themeData, loading: false };
    case designCenterConst.VIEW_THEME_DATA_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    default:
      return state;
  }
};

export default designCenterReducer;



// WEBPACK FOOTER //
// ./src/app/redux/reducers/designCenterReducer.js